module.exports = __webpack_public_path__ + "img/watchshare.d2eb1ded.png";